module.exports = __webpack_public_path__ + "static/img/nuode-b.d59bbf5.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/nuode-b.png
// module id = auRA
// module chunks = 1